export default __webpack_public_path__ + "static/media/logoDark.d8b24a75.svg";